import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { debounceTime, map, mergeMap, take, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, ReplaySubject, Subscription } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ToastController, ModalController, Platform } from '@ionic/angular';
import { PushNotifications } from '@capacitor/push-notifications';
import { FCM } from '@capacitor-community/fcm';
import { EditScheduledMessageModalPage } from '../pages/edit-scheduled-message-modal/edit-scheduled-message-modal.page';
import { getLogger } from 'loglevel';
import { TextableOrganization, TextableUser } from '../backported_types/users';
import { mapToTextableBaseFirestoreDocument, TextableBaseFirestoreDocument } from '../backported_types/base';
import { TextableContact, TextableContactList } from '../backported_types/contact';
import { NoteModalPage } from '../pages/note-modal/note-modal.page';
import { TextableBlast, TextableCannedResponse, TextableReminder } from '../backported_types/messaging';
import { AuthNZService } from '../core/authnz.service';
import { BackendService } from './backend.service';
import "src/polyfills/FirstEmitAsPromise.ts"

const log = getLogger("TextableService");


@Injectable({
  providedIn: 'root'
})
export class TextableService {



  private userSubscription: Subscription;
  public numbers$: BehaviorSubject<TextableUser[]> = new BehaviorSubject(null);

  activeUid;
  public activeNumber$: ReplaySubject<Observable<TextableUser>> = new ReplaySubject(1)

  /**
   * @deprecated
   */
  private activeNumberUID: any;

  isEmailVerified: boolean = true;
  contactList: any;
  contactList$: BehaviorSubject<any> = new BehaviorSubject(null);

  userAuthToken;

  additionalContactsToShow: string[] = []

  constructor(
    private platform: Platform,
    private afa: AngularFireAuth,
    private afs: AngularFirestore,
    private http: HttpClient,
    public modal: ModalController,
    public toastController: ToastController,
    private authnz: AuthNZService,
    private backendService: BackendService
   
  ) {
    
    //when the signed in user changes... (or initializes on page load...)
    this.afa.authState.subscribe(async (user)=>{    
      this.afa.idToken.subscribe(token => {
        this.userAuthToken = token;
      })
    });

    this.authnz.activeNumberProfile$.subscribe((num)=>{
      this.activeNumberUID = num.firebase_document_id;
    });
    
  }

  async setAutoReplyMessage(val){
    let replyMessage;
    if (val == null) {
      let activeNumber = (await this.authnz.activeNumberProfile$.nThEmitAsPromise(1));
      replyMessage = { uid: activeNumber.firebase_document_id }
    } else {
      replyMessage = val
    }

    return this.backendService.backendPost('setAutoReplyMessage', {},{autoReplyMessage: replyMessage})
    
  }
  
  /////////////////////////////////
  //MESSAGE AND CONVERSATIONS QUERY
  /////////////////////////////////
  /**
   * @deprecated
   */
  getMessage(id) {
    return this.afs.doc('messages/'+id).valueChanges().pipe(take(1));
  }
    /**
   * @deprecated
   */
  editMessage(id, data) {
    // Ionic datetime element turns the form's date value to a string. It needs to be converted to a number
    data.date = parseInt(data.date)
    return this.afs.doc('messages/' + id).update(data);
  }
    /**
   * @deprecated
   */
  deleteMessage(message){
    this.afs.doc('messages/'+message).delete()
      .then(async () => {
        const toast = await this.toastController.create({
          message: 'Message deleted.',
          duration: 1500,
          position: 'top',
          color:'danger'
        });
        toast.present();
      })
      .catch(async (err) => {
        const toast = await this.toastController.create({
          message: 'Oops, there was a problem deleting this message. Please try again.',
          duration: 1500,
          position: 'top',
          color:'danger'
        });
        toast.present();
      });
  }
    /**
   * @deprecated
   */

  archiveConversation(contactId){
   return this.afs.doc('contacts/'+contactId).update({
                    read_status:true, 
                    isArchived: true
                  });
  }


  ///////////////
  //CONTACT QUERY
  ///////////////



    /**
   * @deprecated
   */
  updateContactWithSuggestion(id:string,full_name:string) {
    return this.afs.doc('contacts/'+id).update({full_name:full_name});
  }

  /**
   * @deprecated
   */
  async openEditScheduledMessageModal(id) {
    const modal = await this.modal.create({
      component: EditScheduledMessageModalPage,
      componentProps: { id:id }
    });
    
    await modal.present();    
  }
  /**
   * @deprecated
   */
  async openNoteModal(contact) {
    const modal = await this.modal.create({
      component: NoteModalPage,
      componentProps: { contact:contact }
    });
    
    await modal.present();    
  }

    /**
   * @deprecated
   */
  private async backendGet(endpoint, data) { 
      return this.http.get(environment.apiBase + endpoint, {
        headers: {
          'Authorization': 'Bearer ' + this.userAuthToken
        },
        params: data
      }).toPromise();  // TODO: TXBDEV-3024 use firstValueFrom here once we've upgraded angular / RxJs
  }

    /**
   * @deprecated
   */
  addCountryCode(phoneNumber,phonePrefix) {
    return phonePrefix + phoneNumber.replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll(" ", "").replaceAll(phonePrefix, "")
  }
  
  /**
   * Checks whether the specified contact will recieve a consent message 
   * according to the current Textable tenant's configuration parameters
   * and the current User's Organization's congfiguration parameters
   * 
   * @param contact 
   * @deprecated
   */
  async getContactConsentRequirement(contact: any): Promise<Boolean> {   
    if (!contact.contactConsentMessageId) {
      const response = await this.backendGet("getContactConsentRequirement",{
        contact: contact.id
      }) as any;
      return response;
    } else {
      return false;
    }
  }
}
